<template>
  <div class="ph-schedule">
    <h6 class="ph-schedule-title">Автоотчёт в Telegram</h6>
    <div class="ph-schedule-row">
      <label class="ph-field">
        <span>Периодичность</span>
        <select v-model="schedule">
          <option value="off">Не отправлять</option>
          <option value="daily">Каждый день</option>
          <option value="weekly">Раз в неделю</option>
          <option value="monthly">Раз в месяц</option>
        </select>
      </label>
      <label class="ph-field" v-if="schedule !== 'off'">
        <span>Час отправки (МСК)</span>
        <input type="number" min="0" max="23" v-model.number="scheduleHour"/>
      </label>
      <label class="ph-field" v-if="schedule === 'monthly'">
        <span>Число месяца</span>
        <input type="number" min="1" max="31" v-model.number="scheduleDayOfMonth"/>
      </label>
      <button type="button" class="ph-btn" :disabled="busy" @click="save">Сохранить</button>
    </div>
    <div class="ph-schedule-days" v-if="schedule === 'weekly'">
      <span class="ph-field-label">Дни недели</span>
      <label class="ph-day" v-for="d in weekdays" :key="d.v">
        <input type="checkbox" :value="d.v" v-model="scheduleDays"/>
        <span>{{ d.l }}</span>
      </label>
    </div>
    <label class="ph-checkbox">
      <input type="checkbox" v-model="showOutsideList"/>
      <span>Учитывать фразы вне списков в Telegram-отчёте</span>
    </label>
    <p class="ph-schedule-hint">{{ hint }}</p>
    <p v-if="error" class="ph-err">{{ error }}</p>
  </div>
</template>

<script>
import axios from 'axios';

const LABELS = { off: 'выключен', daily: 'каждый день', weekly: 'раз в неделю', monthly: 'раз в месяц' };
const WEEKDAYS = [
  { v: 1, l: 'ПН' }, { v: 2, l: 'ВТ' }, { v: 3, l: 'СР' }, { v: 4, l: 'ЧТ' },
  { v: 5, l: 'ПТ' }, { v: 6, l: 'СБ' }, { v: 0, l: 'ВС' },
];

export default {
  name: 'PhraseScheduleBox',
  props: {
    projectId: { type: String, default: '' },
    set: { type: Object, required: true },
  },
  emits: ['updated'],
  data() {
    return {
      hostApi: process.env.VUE_APP_API_URL,
      schedule: this.set.schedule,
      scheduleHour: this.set.scheduleHour,
      scheduleDays: (this.set.scheduleDays || [1]).slice(),
      scheduleDayOfMonth: this.set.scheduleDayOfMonth || 1,
      showOutsideList: this.set.showOutsideList,
      weekdays: WEEKDAYS,
      busy: false,
      error: '',
    };
  },
  watch: {
    set: {
      immediate: true,
      handler(s) {
        this.schedule = s.schedule;
        this.scheduleHour = s.scheduleHour;
        this.scheduleDays = (s.scheduleDays || [1]).slice();
        this.scheduleDayOfMonth = s.scheduleDayOfMonth || 1;
        this.showOutsideList = s.showOutsideList;
      },
    },
  },
  computed: {
    hint() {
      if (this.schedule === 'off') return 'Отчёт уходит в Telegram: ' + LABELS.off + '.';
      const sent = this.set.lastSentAt
        ? ' Последняя отправка: ' + this.set.lastSentAt.slice(0, 16).replace('T', ' ') + '.'
        : '';
      // Правило периода общее для всех расписаний: только полные завершённые
      // московские сутки, текущий день в отчёт не входит никогда.
      let extra = ' Период — полные прошедшие сутки по Москве, текущий день в отчёт не входит.';
      if (this.schedule === 'daily') {
        extra += ' То есть отчёт за вчерашние сутки целиком, с 00:00 до 23:59 МСК.';
      } else if (this.schedule === 'weekly') {
        extra += ' То есть с прошлого отмеченного дня по вчерашние сутки включительно'
          + ' (при одном отмеченном дне это ровно 7 полных суток).';
      } else if (this.schedule === 'monthly') {
        extra += ' То есть последние 30 полных суток, заканчивая вчерашними.'
          + ' Если в месяце нет выбранного числа — отчёт уйдёт в последний день месяца.';
      }
      return 'Отчёт уходит в Telegram: ' + LABELS[this.schedule] + ' в ' + this.scheduleHour + ':00 МСК.' + sent + extra;
    },
  },
  methods: {
    async save() {
      this.error = '';
      if (this.schedule === 'weekly' && this.scheduleDays.length === 0) {
        this.error = 'Выберите хотя бы один день недели';
        return;
      }
      this.busy = true;
      try {
        await axios.post(this.hostApi + '/api/v1/phraseset/update', {
          clientId: localStorage.getItem('clientId'),
          projectId: this.projectId,
          setId: this.set.id,
          name: this.set.name,
          schedule: this.schedule,
          scheduleHour: this.scheduleHour,
          scheduleDays: this.scheduleDays,
          scheduleDayOfMonth: this.scheduleDayOfMonth,
          showOutsideList: this.showOutsideList,
        });
        this.$emit('updated');
      } catch (e) {
        this.error = (e.response && e.response.data && e.response.data.error) || 'Не удалось сохранить расписание';
      } finally {
        this.busy = false;
      }
    },
  },
};
</script>

<style scoped>
.ph-schedule { margin-top: 20px; padding: 12px; border: 1px solid rgba(127,127,127,0.3); border-radius: 6px; }
.ph-schedule-title { margin: 0 0 10px; font-size: 14px; }
.ph-schedule-row { display: flex; flex-wrap: wrap; gap: 12px; align-items: flex-end; }
.ph-schedule-hint { margin: 8px 0 0; font-size: 12px; opacity: 0.7; }
.ph-schedule-days { display: flex; flex-wrap: wrap; align-items: center; gap: 10px; margin-top: 10px; font-size: 13px; }
.ph-field-label { font-size: 13px; opacity: 0.8; }
.ph-day { display: flex; align-items: center; gap: 4px; cursor: pointer; }
.ph-checkbox { display: flex; align-items: center; gap: 6px; margin-top: 10px; font-size: 13px; cursor: pointer; }
.ph-field { display: flex; flex-direction: column; gap: 4px; font-size: 13px; }
.ph-field select, .ph-field input { padding: 5px 8px; }
.ph-btn { padding: 5px 12px; border: 1px solid currentColor; background: transparent; cursor: pointer; border-radius: 4px; }
.ph-btn[disabled] { opacity: 0.5; cursor: default; }
.ph-err { color: #b02a37; font-size: 13px; margin: 4px 0 0; }
</style>
